import React from "react";
import LoadFinishedGeneral from "components/MainApp/organisms/LoadFinishedGeneral"


import styles from "./AddBusinessNodeSuccess.module.scss";
import i18n from "i18n";

 const AddBusinessNodeSuccess = ({name, id, boldButtonFunc}) => {
 
    return (
      <LoadFinishedGeneral
        title={i18n.t("branch.create.successfully", {name: name})}
        boldButtonLabel={i18n.t("go.to.list")}
        buttonLabel={i18n.t("set.up.locations")}
        boldButtonLink={"/admin/businessnodes"}
        buttonLink={`/admin/businessnodes/locationssetup/${id}`}
        boldButtonFunc={boldButtonFunc}
      > 
        <div className={styles["add-businessnode-success-container"]}>
            <div className={styles["add-businessnode-success-text"]}>{i18n.t("set.up.locations.question")}</div>
        </div>
      </LoadFinishedGeneral>
    )
  
}

export default AddBusinessNodeSuccess;